import { Component } from '@angular/core';

@Component({
  selector: 'nrk-content',
  templateUrl: './nrk-content.component.html',
  styleUrls: ['./nrk-content.component.scss']
})
export class NrkContentComponent {

}
